
<!--@description 快捷采购页
    @author cc
    @date 2020-3-25
  -->
<template>
  <cc-container>
    <skeleton v-show="showSkeleton" />
    <cc-main v-show="!showSkeleton" style="overflow:auto;height:100%;">
      <cc-container class="categorylist" style="height:100%;">
        <cc-header-nav style="z-index:100">
          <!-- 扫一扫 -->
          <cc-svg-icon
            @click="openScanning"
            icon-class="scan2"
            class-name="left-arrow"
            slot="left"
            size=".2rem"
            v-if="get_coupon_show"
          ></cc-svg-icon>
          <!-- 搜索 -->
          <div class="search-box" slot="center">
            <input
              v-model="searchval"
              type="text"
              placeholder="请输入通用名/商品名/厂家"
              class="input-search"
              @click="search()"
            />
            <cc-svg-icon size=".16rem" class-name="search-icon-main" icon-class="search"></cc-svg-icon>
          </div>
          <template slot="right">
            <div class="ellipsis">
              <van-icon
                class="ellipsis-icon"
                name="ellipsis"
                @click.stop="isShowSmallNav = !isShowSmallNav"
                v-if="!get_coupon_show"
              />
            </div>
          </template>
          <!-- 通知信息 -->
          <!-- <cc-svg-icon icon-class="notice-news" slot="right" size=".2rem"></cc-svg-icon> -->
        </cc-header-nav>
        <!-- tab切换 start-->
        <ul class="ct_tag">
          <li>
            <span class="ct_sel" :class="active==0?'active':''" @click="change(0)">默认</span>
          </li>
          <li>
            <span class="ct_sel" :class="active==1?'active':''" @click="change(1)">最新</span>
          </li>
          <li>
            <span class="ct_sel" @click="allCalss()">
              {{classTxt}}
              <cc-svg-icon
                style="vertical-align: middle;"
                size=".10rem"
                class-name="class-down-icon active"
                :icon-class="showcate?'class-arrow':'class-down'"
              ></cc-svg-icon>
            </span>
          </li>
          <li>
            <span @click="filter()">
              筛选
              <cc-svg-icon
                style="vertical-align: middle;"
                size=".14rem"
                class-name="filter-icon"
                icon-class="filter"
              ></cc-svg-icon>
            </span>
          </li>
        </ul>
        <!-- tab切换end -->
        <!-- 全部分类start -->
        <div v-if="showcate" class="cate">
          <div class="cate-left">
            <ul>
              <li
                v-for="(cate,index) in cateData"
                :key="index"
                class="cate-item"
                :class="index==cateActive?'cate-item-active':''"
                @click="changeBigCate(index,cate.id)"
              >{{cate.category_name}}</li>
            </ul>
          </div>
          <div class="cate-right" style="padding-bottom:0;">
            <ul>
              <li
                v-for="(ele,index) in cateRightData"
                :key="index"
                @click="changeSmallCate(index,ele)"
                :class="sactive==index?'s-active':''"
              >{{ele.child_category_name}}</li>
            </ul>
          </div>
        </div>
        <div class="coupon" v-if="get_coupon_id&&productsData.length>0">
          <cc-svg-icon
            icon-class="notice"
            class-name="notice"
            size=".14rem"
            @click="brandSwitch=!brandSwitch"
          ></cc-svg-icon>
          <span class="coupon-txt" v-if="filterData">
            以下商品可使用
            {{filterData.coupon_info&&!filterData.coupon_info.full_amount*1?'无门槛金额满':filterData.coupon_info&&filterData.coupon_info.coupon_type===1?'减'+filterData.coupon_info.reduce_money:'打'+filterData && filterData.coupon_info && filterData.coupon_info.discount}}
            优惠券
          </span>
          <div class="coupon-time" v-if="coupon_info">
            <b>{{coupon_info.countDown.h}}</b>
            <span>时</span>
            <b>{{coupon_info.countDown.m}}</b>
            <span>分</span>
            <b>{{coupon_info.countDown.s}}</b>
            <span>秒</span>
          </div>
        </div>
        <!-- 全部分类end -->
        <cc-main ref="main">
          <cc-pull-refresh
            v-model="isLoading"
            :disabled="disabled"
            @refresh="onRefresh"
            class="pull-refresh"
          >
            <!-- 无数据时start -->
            <div v-show="!productsData.length && !m_loading" class="null_goods">
              <img src="./../../assets/img/null_goods.png" />
              <p>抱歉，搜索不到相关产品</p>
              <p>先逛逛其他产品吧</p>
              <a href="/#/home" class="null_see_btn">去逛逛</a>
              <a href="/user/proposal" class="null_mes_btn">去留言</a>
            </div>
            <!-- 无数据时end -->
            <div class="categorylist-data" v-show="productsData.length>0">
              <van-list
                v-model="m_loading"
                :finished="m_finished"
                :finished-text="m_finishedText"
                @load="mHandlePullUpLoadMore"
                :immediate-check="m_immediateCheck"
                class="categorylist-data-products"
                :class="changeBlock?'change-block':''"
              >
                <div class="xpt-product" v-for="(item,index) in productsData" :key="index">
                  <div>
                    <div class="xpt-product-img" @click="to (item)">
                      <img class="img" v-lazy="item.image" alt />
                      <div
                        class="sellOut"
                        v-if="getGoodsType(item)===2"
                      >缺货</div>
                      <div class="preSellSign" v-if="item.type==8">预售</div>
                      <i
                        class="xpt-icons"
                        :class="{
                                'xpt-icons__manzeng': item.type == 5,
                                'xpt-icons__huodong': item.type == 4,
                                'xpt-icons__cuxiao': item.type == 3 && !item.is_bargain,
                                'xpt-icons__tejia': item.type == 2 && +item.is_seckill ===0,
                                'xpt-icons__miaosha': item.type == 2 && +item.is_seckill ===1,
                              }"
                      ></i>
                      <!-- 全场促销 -->
                      <i class="qccx_img" v-if="item.is_enjoy_promotion"></i>
                    </div>
                  </div>
                  <div class="xpt-product-right">
                    <div @click="to(item)">
                      <div>
                        <div class="xpt-product-right-title">
                          <span class="mr5">{{item.general_name}}</span>
                          <span>{{item.norms}}</span>
                        </div>
                        <!-- 后台可控字段 -->
                        <div class="xpt-product-right-line ell" v-if="item.showproduct_name">
                          <span>{{'商品名：'+item.product_name }}</span>
                        </div>
                        <div class="xpt-product-right-line ell" v-if="item.showbatch_code">
                          <span>{{'批号：'+item.batch_code }}</span>
                        </div>
                        <div
                          class="xpt-product-right-line ell1"
                          v-if="item.showproduce_unit"
                        >{{'厂家：'+item.produce_unit}}</div>
                        <div
                          class="xpt-product-right-line"
                          v-if="item.showsource_area"
                        >{{'原产地：'+item.source_area}}</div>
                      </div>
                      <div class="xpt-product-right-price">
                        <span class="f15" v-if="!getLoginStatus.data.member_id">会员可见</span>
                        <!-- 区域经销>预售>议价商品-->
                        <!-- 1. 区域经销-->
                        <span class="f15" v-else-if="item.is_view">{{item.jiage}}</span>
                        <!-- 2. 预售商品-->
                        <template v-else-if="item.type==8&&item.is_view==0">
                          <span class="f12" v-if="!isNaN(item.jiage)">￥</span>
                          <span :class="isNaN(item.jiage)?'f15':'f18'">{{item.jiage}}</span>
                        </template>
                        <!-- 3.议价商品 -->
                        <span
                          class="f15"
                          v-else-if="item.is_bargain === 1 && item.tag === 2 && item.type!==8"
                        >议价商品</span>
                        <template v-else>
                          <span class="f12" v-if="!isNaN(item.jiage)">￥</span>
                          <span :class="isNaN(item.jiage)?'f15':'f18'">{{item.jiage}}</span>
                        </template>
                        <!-- 原价(只有特价商品和秒杀商品有这个价格) -->
                        <span v-if="item.type == 2 && !isNaN(item.shanchu_price)&&item.userid">
                          <del style="color:#BFBDBD;">{{'￥'+item.shanchu_price}}</del>
                        </span>
                        <div class="shopcart">
                          <cart-btn
                           :btn-type="getGoodsType(item)"
                            @openCart="cartBtn(item,cartIconColor(item)?1:0)">
                          </cart-btn>
                        </div>
                      </div>
                      <div
                        class="xpt-product__line ell1"
                        style="margin-bottom:0.03rem"
                        v-if="item.discount_prices&&getLoginStatus.data.member_id===0"
                        v-html="'会员可见'"
                      ></div>
                      <template v-else>
                        <div
                          class="xpt-product__line ell1"
                          style="margin-bottom:0.03rem"
                          v-if="item.discount_prices && item.discount_prices !=='赠品'"
                          v-html="['区域经销','会员可见'].indexOf(item.discount_prices) !== -1  ? item.discount_prices : item.is_bargain && item.tag == 2? '议价商品':('折后价：￥'  +item.discount_prices)"
                        ></div>
                      </template>
                    </div>
                    <div class="xpt-product-right-line" v-if="item.gettags.length">
                      <div>
                        <span v-for="(tag, index) in item.gettags" :key="tag.index">
                          <span
                            v-if="index < 3"
                            class="xpt-tag-r"
                            :style="{'borderColor':tag.color,'color':tag.color}"
                          >{{tag.name}}</span>
                        </span>
                      </div>
                    </div>
                    <!-- 促销套餐 -->
                    <div
                      class="xpt-product-right-line"
                      v-if="item.userid&&item.type==3&&!item.is_bargain"
                      style="margin-bottom:0;"
                    >
                      <span class="activity-text">商品参加组合套餐，</span>
                      <span class="activity-text" @click="goPromotion(item.for_id)">点击购买></span>
                    </div>
                    <div
                      style="margin-bottom:0;"
                      class="xpt-product-right-line"
                      v-if="item.userid&&item.goods_introduc"
                    >
                      <span class="activity-text act">{{item.goods_introduc}}</span>
                    </div>
                  </div>
                </div>
              </van-list>
            </div>
          </cc-pull-refresh>
        </cc-main>
        <!-- 全部分类的遮造层 -->
        <div class="shade" v-if="showAllshade" @click="allCalss()"></div>
        <div class="shade" v-if="showFiltershade" @click="filter()"></div>
      </cc-container>
    </cc-main>
    <!-- 返回顶部 -->
    <div @click="backTop" class="back-top" v-if="backtopshow" >                       
      <img src="./../../assets/img/home/top.png" alt />
    </div>
    <!-- <div @click="backRecommend" class="back-recommend" style="bottom:.5rem" v-if="backrecommendshow">
      <img src="./../../assets/img/home/xiala.png" alt />
    </div> -->
    <!-- 筛选start -->
    <div class="filterout" v-if="showFilter">
      <div class="filter">
        <div class="filter-box" v-if="brandData.length">
          <div class="filter-title">
            <span class="filter-class">品牌</span>
            <p class="filter-select-txt">{{filterActive.brandVal}}</p>
            <cc-svg-icon
              :icon-class="!brandSwitch?'down-arrow':'up-arrow'"
              class-name="down-arrow"
              size=".2rem"
              @click="brandSwitch=!brandSwitch"
            ></cc-svg-icon>
          </div>
          <div class="screen-body">
            <span
              @click="changebrand(item,index)"
              v-for="(item,index) in brandData"
              :key="item.id"
              class="brand-class"
              :class="filterActive.brandClassActive===index? 'brand-class-active':''"
            >{{item.title}}</span>
          </div>
        </div>
        <div class="filter-box" v-if="tagData.length">
          <div class="filter-title">
            <span class="filter-class">标签</span>
            <p class="filter-select-txt">{{filterActive.tagVal}}</p>
            <cc-svg-icon
              :icon-class="!tagSwitch?'down-arrow':'up-arrow'"
              class-name="down-arrow"
              size=".2rem"
              @click="tagSwitch=!tagSwitch"
            ></cc-svg-icon>
          </div>
          <div class="screen-body">
            <span
              @click="changetag(item,index)"
              v-for="(item,index) in tagData"
              :key="item.id"
              class="brand-class"
              :class="filterActive.tagClassActive===index?'brand-class-active':''"
            >{{item.name}}</span>
          </div>
        </div>
        <div>
          <p class="filter-title">
            <span class="filter-class">库存</span>
          </p>
          <div class="screen-body">
            <span
              @click="changestock()"
              :class="filterActive.stockClassActive?'brand-class-active':''"
              class="brand-class"
            >只看有货</span>
          </div>
        </div>
        <div style="border-bottom:none;">
          <p class="filter-title">
            <span class="filter-class">中包装拆销</span>
          </p>
          <div class="screen-body">
            <span
              class="brand-class"
              @click="changeSeparate(1)"
              :class="filterActive.separateClassActive===1?'brand-class-active':''"
            >整件</span>
            <span
              class="brand-class"
              @click="changeSeparate(0)"
              :class="filterActive.separateClassActive===0?'brand-class-active':''"
            >拆零</span>
          </div>
        </div>
      </div>
      <div class="filter-bottom" style="padding-bottom:0;">
        <span @click="reset()">重置</span>
        <span @click="submit()">确定</span>
      </div>
    </div>
    <!-- 筛选end-->
    <cc-footer style="z-index:100" v-if="get_coupon_show">
      <cc-nav></cc-nav>
    </cc-footer>
    <!-- 购物车弹窗start(有库存) -->
      <cc-shop-cart
        :isShowPopup="showcart"
        :cartItemData="cartItem"
        @close="showcart=false"
        :height="556"
        :HeaderHight="88"
        ref="shopCart"
      ></cc-shop-cart>
    <!-- 购物车弹窗end -->
    <!-- 缺货弹窗start-->
      <cc-nogoods-remind
        :isShowPopup="shownogoods"
        :cartItem="cartItem"
        :height="426"
        @close="shownogoods=false"
        ref="nogoods"
      ></cc-nogoods-remind>
    <!-- 缺货弹窗end -->
    <!-- 促销套餐详情start -->
    <cc-promot-cart
      :isShowPopup="showCartPromot"
      :promotCartData="promotCartData"
      :height="556"
      @close="showCartPromot=false"
      v-if="showCartPromot"
    ></cc-promot-cart>
    <!-- 促销套餐详情end -->
    <cc-small-nav v-model="isShowSmallNav" />
  </cc-container>
</template>
<script>
import { scanning } from '~utils/xcode.js'
import ListMixin from '@/mixins/list'
import Command from '@/mixins/command'
import cartStep from '@/mixins/cartStep'
import { scrollTop } from '~utils'
import CountDownMixin from '@/mixins/countDown'

import {
  productCategory,
  productCategoryList,
  categorylist
} from '@/fetch/categorylist/index.js'
import Vue from 'vue'
import Skeleton from './skeleton.vue'
import CartBtn from './../home/components/cart-btn.vue'
import { List, Lazyload, Toast, Icon } from 'vant'
Vue.use(List)
  .use(Lazyload)
  .use(Toast)
  .use(Icon)
let toast = null
export default {
  name: 'categorylist',
  components: { Skeleton, CartBtn },
  mixins: [ListMixin, Command, cartStep, CountDownMixin],
  data () {
    return {
      // 控制vant下拉加载中
      changeBlock: true,
      // 促销套餐数据
      promotCartData: '',
      // 促销套餐加入购物车开关
      showCartPromot: false,
      // 骨架屏开关
      showSkeleton: true,
      sactive: null,
      // 搜索绑定值
      searchval: '',
      active: 0,
      // 分类开关
      showcate: false,
      // 筛选开关
      showFilter: null,
      // 下拉刷新开关
      isLoading: false,
      // 遮住层
      showAllshade: false,
      // 筛选的遮住层
      showFiltershade: false,
      // 分类动态样式
      cateActive: 0,
      // all分类data
      cateData: [],
      // 小分类data
      cateRightData: '',
      // 搜索表单数据
      pagination: {
        // 页码
        page: 1,
        // 关键字
        keyword: '',
        // 父类
        pid: '',
        // 子类
        cid: '',
        // 商品排序类型
        type: '',
        // 排序
        sort: '',
        // 排序
        nodesc: '',
        // 筛选品牌id
        brand: '',
        // 筛选标签id
        tags: '',
        // 筛选库存
        stock: '',
        // 筛选中包装是否拆销
        is_separate: '',
        // 未知作用
        apitype: 2,
        // 优惠券id
        get_coupon_id: '',
        // 搜索关键字类型：关键字？编码
        types: ''
      },
      // 商品属性展示
      not_show_field_arr: [],
      // 列表商品数据
      productsData: '',
      loadingDialog: null,
      classTxt: '全部分类',
      // 滚动向上图标开关
      backtopshow: false,
      // 滚动向下图标开关
      // backrecommendshow: false,
      // 筛选的数据
      filterData: null,
      // 筛选
      filterActive: {
        brandClassActive: null,
        tagClassActive: null,
        stockClassActive: false,
        separateClassActive: null,
        // 品牌选中的val
        brandVal: '',
        // 标签选中的val
        tagVal: ''
      },
      brandSwitch: false,
      // 标签显示所有的开关
      tagSwitch: false,
      get_coupon_id: '',
      coupon_info: null,
      disabled: false,
      // 优惠券进来的
      get_coupon_show: true,
      isShowSmallNav: false
    }
  },
  computed: {
    brandData () {
      var arr = []
      if (this.filterData) {
        arr = this.brandSwitch
          ? this.filterData.brand_list
          : this.filterData.brand_list.filter((item, index) => {
            return index < 9
          })
      }
      return arr
    },
    tagData () {
      var arr = []
      if (this.filterData) {
        arr = this.tagSwitch
          ? this.filterData.tags_list
          : this.filterData.tags_list.filter((item, index) => {
            return index < 6
          })
      }
      return arr
    }
  },
  mounted () {
    this.get_coupon_show = !+this.$route.query.get_coupon_id
    this.startload()
  },
  methods: {
    judgeTime (item) {
      return parseInt(+item.end_time - +item.now_time)
    },
    getGoodsType (item) {
      if (this.getLoginStatus.data.member_id) {
        if (item.is_view === 1) {
          return 1 // 区域经销
        } else if (item.type === 8) {
          // 预售商品
          return +item.presell_stock === 0 ? 2 : 0
        } else {
          // 议价商品
          if (+item.is_bargain === 1 && item.tag === 2) {
            return 1
          } else if (+item.goodsstock === 0 && this.getLoadSettingStatus.data.is_empty_stock === 0) {
            return 2
          } else {
            return 0
          }
        }
      } else {
        return 0
      }
    },
    startload () {
      // 因为缓传 搜索进来需要初始化数据
      this.filterActive = this.$options.data().filterActive
      this.cateActive = this.$options.data().cateActive
      this.sactive = this.$options.data().sactive
      this.classTxt = this.$options.data().classTxt
      this.pagination = this.$options.data().pagination
      this.$nextTick(() => {
        if (this.$route.query) {
          this.get_coupon_id = this.$route.query.get_coupon_id
          Object.keys(this.pagination).map(k => {
            if (Object.keys(this.$route.query).includes(k)) {
              this.pagination[k] = this.$route.query[k]
            }
          })
        }
        this.searchval = this.$route.query.keyword
          ? this.$route.query.keyword
          : ''
        this.getProductCategory()
        this.searchData()
        this.categorylist()
      })
      setTimeout(() => {
        this.scrollAndref()
        if (this.$refs.main) {
          this.$refs.main.$el.addEventListener(
            'scroll',
            this.scrollEvent,
            true
          )
        }
      }, 2000)
    },
    /**
     * 添加活动内容字段
     */
    addActivitesField (item) {
      var content = ''
      var goodtype = item.type
      content = !this.getLoadSettingStatus
        ? '会员可见'
        : goodtype === 2
          ? item.special_content
          : goodtype === 4
            ? item.activity_introduc
            : goodtype === 5
              ? item.gifts_introduc
              : ''
      this.$set(item, 'goods_introduc', content)
    },
    /**
     * 扫一扫
     */
    openScanning () {
      scanning(this)
    },
    /**
     * 滚动到顶部加刷新
     */
    scrollAndref () {
      if (this.$refs.main) {
        this.$refs.main.$el.onscroll = e => {
          if (e.target.scrollTop > 0) {
            this.disabled = true
          } else {
            this.disabled = false
          }
        }
        this.$refs.main.$el.addEventListener('scroll', this.scrollEvent, true)
      }
    },
    /**
     *  下拉刷新
     */
    onRefresh () {
      this.changeBlock = true
      this.mReset()
      this.getProductCategory()
      this.categorylist()
      this.loadData(true)
      this.scrollAndref()
      this.getSetting()
    },
    /**
     *  头部的tab切换
     */
    change (index) {
      toast = Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      this.active = index
      this.pagination.type = index ? 'new' : ''
      // tab切换时
      this.showFilter = this.showFiltershade = this.showcate = this.showAllshade = false
      this.searchData()
    },
    /**
     *  筛选
     */
    filter () {
      this.showFilter = !this.showFilter
      this.showFiltershade = !this.showFiltershade
      this.showcate = this.showFilter ? false : this.showcate
      this.showAllshade = this.showFilter ? false : this.showAllshade
    },
    /**
     *  全部分类
     */
    allCalss () {
      this.showcate = !this.showcate
      this.showAllshade = !this.showAllshade
      this.showFilter = this.showcate ? false : this.showFilter
      this.showFiltershade = this.showcate ? false : this.showFiltershade
    },
    /**
     *  商品分类数据
     */
    async getProductCategory () {
      this.cateData = []
      let { data } = await productCategory()
      this.showSkeleton = false
      var obj = { category_name: '全部分类', child: [] }
      this.cateData = data.data
      this.cateData.unshift(obj)
    },
    /**
     *  跳转到详情页
     */
    to (item) {
      // window.location.href = '/product/detail?id=' + item.id
      this.$router.push({
        path: '/goods-details',
        query: { goods_id: item.id, type: item.type }
      })
    },
    /**
     *  商品大分类切换
     */
    changeBigCate (index, pid) {
      this.cateActive = index
      this.pagination.pid = pid
      this.cateData.forEach((item, ind) => {
        if (index === ind) {
          this.cateRightData = item.child
          this.sactive = null
        }
      })
      if (!index) {
        toast = Toast.loading({
          message: '加载中...',
          forbidClick: true
        })
        this.classTxt = '全部分类'
        this.pagination.cid = ''
        this.allCalss()
        this.searchData()
      }
    },
    /**
     *  商品小分类切换
     */
    changeSmallCate (index, ele) {
      toast = Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      this.sactive = index
      this.pagination.cid = ele.child_id
      this.allCalss()
      this.searchData()
      this.classTxt = ele.child_category_name
    },
    /**
     *  商品数据
     */
    async loadData (reset) {
      // if (!reset) {
      //   this.productsData = []
      // }
      this.mRequest()
      this.pagination.page = this.m_page.curr
      let res = await productCategoryList(this.pagination)
      this.$tips(
        res,
        {
          tip: false
        },
        res => {
          if (toast) {
            toast.clear()
          }
          this.isLoading = false
          this.changeBlock = false

          if (res.goods_data.length) {
            this.not_show_field_arr = res.goods_data[0].not_show_field_arr
          }
          if (res.goods_data.length === 0) {
            if (reset) {
              this.productsData = []
            }
            // 全部数据加载完成
            this.m_finishedText = '-- 我也是有底线的 --'
            this.mEnd()
          } else {
            res.goods_data.forEach(item => {
              this.addActivitesField(item)
            })
            res.goods_data = this.addGoodField(res.goods_data)
            if (reset) {
              // this.total.clear()
              this.$refs.main.$el.scrollTop = 0
              this.productsData = res.goods_data
            } else {
              this.productsData = [...this.productsData, ...res.goods_data]
            }
            if (res.goods_data.length < 10) {
              this.m_finishedText = '-- 我也是有底线的 --'
              this.mEnd()
            }
          }
        }
      )
      this.mSuccess()
    },
    /**
     *  搜索数据
     */
    searchData () {
      this.mReset()
      this.loadData(true)
    },
    submit () {
      toast = Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      this.searchData()
      this.showFilter = false
      this.showFiltershade = false
    },
    /**
     *  点击购物车购买
     */
    cartBtn (item, cartColor) {
      this.cartBtnAlter(item, cartColor)
    },
    /**
     * @description 快捷采购筛选数据
     */
    async categorylist () {
      // this.filterData = null
      let params = { get_coupon_id: this.get_coupon_id }
      let { data } = await categorylist(params)
      this.filterData = data
      /**
       * url传参的，要选中对应的筛选数据
       */
      if (this.$route.query.tags) {
        this.filterActive.tagClassActive = this.filterData.tags_list.findIndex(item => item.id === this.$route.query.tags)
        if (+this.filterActive.tagClassActive !== -1) {
          this.filterActive.tagVal = this.filterData.tags_list[this.filterActive.tagClassActive]['name']
        }
      }
      if (this.$route.query.brand) {
        this.filterActive.brandClassActive = this.filterData.brand_list.findIndex(item => item.id === this.$route.query.brand)
        if (+this.filterActive.brandClassActive !== -1) {
          this.filterActive.brandVal = this.filterData.brand_list[this.filterActive.brandClassActive]['title']
        }
      }
      if (this.$route.query.stock) {
        this.filterActive.stockClassActive = true
      }
      if (this.$route.query.is_separate) {
        this.filterActive.separateClassActive = +this.$route.query.is_separate
      }
      this.coupon_info = this.filterData.coupon_info
      this.coupon_info.now_time = this.filterData.now_time
      this.$set(this.coupon_info, 'countDown', {
        d: '',
        h: '',
        m: '',
        s: ''
      })
      this.countDown(this.coupon_info)
    },
    /**
     * @description 筛选品牌
     */
    changebrand (item, index) {
      if (this.filterActive.brandClassActive === index) {
        this.filterActive.brandClassActive = null
        this.pagination.brand = null
        this.filterActive.brandVal = ''
      } else {
        this.filterActive.brandClassActive = index
        this.pagination.brand = item.id
        this.filterActive.brandVal = item.title
      }
    },
    tagMore () {
      this.tagSwitch = !this.tagSwitch
    },
    /**
     * @description 筛选标签
     */
    changetag (item, index) {
      if (this.filterActive.tagClassActive === index) {
        this.filterActive.tagClassActive = null
        this.pagination.tags = null
        this.filterActive.tagVal = ''
      } else {
        this.filterActive.tagClassActive = index
        this.pagination.tags = item.id
        this.filterActive.tagVal = item.name
      }
    },
    /**
     * @description 筛选库存
     */
    changestock () {
      this.filterActive.stockClassActive = !this.filterActive.stockClassActive
      this.filterActive.stockClassActive
        ? (this.pagination.stock = 1)
        : (this.pagination.stock = 0)
    },
    /**
     * @description 筛选整件
     */
    changeSeparate (ele) {
      if (this.filterActive.separateClassActive === ele) {
        this.filterActive.separateClassActive = null
        this.pagination.is_separate = ''
      } else {
        this.filterActive.separateClassActive = ele
        this.pagination.is_separate = ele
      }
    },
    /**
     * @description 重置
     */
    reset () {
      this.pagination.brand = ''
      this.pagination.tags = ''
      this.pagination.stock = 0
      this.pagination.is_separate = ''
      this.filterActive = this.$options.data().filterActive
    },
    /**
     * @description 返回顶部
     */
    scrollEvent () {
      var scrollTop = this.$refs.main.$el.scrollTop
      // if (scrollTop > 10) {
      //   // 向下箭头
      //   this.backrecommendshow = true
      // } else if (scrollTop <= 10) {
      //   this.backrecommendshow = false
      // }
      // if (scrollTop >= 2100) {
      //   this.backrecommendshow = false
      //   this.backtopshow = true
      // } else {
      //   // 向上箭头
      //   this.backtopshow = false
      // }
      this.backtopshow = scrollTop >= 1500
    },
    /**
     * @description 返回顶部(向上走)
     */
    backTop () {
      scrollTop(this.$refs.main)
    },
    /**
     * @description 返回顶部(向下走)
     */
    // backRecommend () {
    //   scrollBottom(this.$refs.main)
    // },
    search () {
      this.$router.push({
        path: '/search',
        query: { keyword: this.searchval, types: this.pagination.types }
      })
    }
  },
  activated () {
    // 详情页 还没有重构 从详情页面进来有数据重复了
    // 只有从search页面进来才重新请求数据，其它页面的则缓传
    if (
      sessionStorage.getItem('isSearch') &&
      sessionStorage.getItem('scrollcate')
    ) {
      // 有些筛选和分类的数据要置空的
      this.startload()
      sessionStorage.removeItem('isSearch')
    }
    if (sessionStorage.getItem('scrollcate') && this.$refs.main) {
      this.$refs.main.$el.scrollTop = sessionStorage.getItem('scrollcate')
    }
  },
  deactivated () {
    if (this.$refs.main) {
      sessionStorage.setItem('scrollcate', this.$refs.main.$el.scrollTop)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~styles/index.scss";
.ellipsis {
  width: 50%;
  height: 100%;
  @include center();
  transform: translateX(-5px);
  &-icon {
    transform: rotate(90deg);
  }
}
.categorylist {
  background: #fff;
  // tab切换start
  .ct_tag {
    display: flex;
    background: #fff;
    border-bottom: 1px solid #e5e5e5;
    z-index: 999;
    li {
      flex: 1;
      height: 44px;
      @include center();
      font-size: 12px;
      box-sizing: border-box;
    }
    li:nth-child(3) {
      color: var(--APP_theme_color);
    }
    .active {
      color: var(--APP_theme_color);
    }
  }
  // tab切换end
  //全部分类弹窗start
  .cate {
    position: fixed;
    top: 86px;
    width: 100%;
    height: 276px;
    overflow: hidden;
    border-bottom: 1px solid #e5e5e5;
    z-index: 95;
    background: #fff;
    padding: 4px 0;
    border-radius: 0 0 10px 10px;
    box-sizing: border-box;
    display: flex;
    &-left {
      background: #f2f2f2;
      width: 127px;
      height: 276px;
      overflow: auto;
      .cate-item {
        width: 100%;
        height: 45px;
        @include center();
        box-sizing: border-box;
        font-size: 13px;
      }
      .cate-item-active {
        background: #fff;
        border-left: 3px solid var(--APP_theme_color);
        font-size: 15px;
        font-weight: 600;
        color: var(--APP_theme_color);
      }
    }
    &-right {
      background: #fff;
      height: 276px;
      overflow: auto;
      width: 100%;
      li {
        height: 46px;
        display: flex;
        align-items: center;
        padding-left: 45px;
        font-size: 12px;
      }
      .s-active {
        color: var(--APP_theme_color);
      }
    }
  }
  //全部分类弹窗end

  .shade {
    position: fixed;
    top: 45px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 90;
  }
  // 商品列表页样式start
  .xpt-product {
    background: #fff;
    padding: 15px 0 0 10px;
    display: flex;
    &-img {
      @include wh(100px, 100px);
      position: relative;
      margin: 0 20px 10px 0;
      img {
        @include wh(100px, 100px);
        border-radius: 4px;
      }
    }
    .ell1 {
      @include ell();
    }
    &-right {
      padding-right: 15px;
      border-bottom: 1px solid #f2f2f2;
      padding-bottom: 15px;
      width: 223px;
      &-line {
        color: #777777;
        font-size: 12px;
        min-height: 14px;
        margin-bottom: 3px;
        > span {
          display: inline-block;
        }
      }
      &-title {
        @include ell(2);
        font-size: 15px;
        color: #333333;
      }
      &-price {
        margin: 12px 0 3px 0;
        > span {
          color: #ea2727;
          display: inline-block;
        }
        .shopcart {
          float: right;
        }
      }
      .xpt-tag-r {
        font-size: 10px;
        margin-right: 5px;
        text-align: center;
        line-height: 14px;
        border-radius: 2px;
        border: 1px solid #fff;
      }
      .activity-text {
        @include sc(12px, #f37f7f);
        display: inline-block;
      }
      .act {
        @include ell();
      }
    }
  }
  // 商品列表页样式end
}
// 筛选弹窗start
.filterout {
  width: 3.37rem;
  position: fixed;
  top: 0px;
  bottom: 0;
  right: 0;
  z-index: 1000;
  background: #fff;
  border-radius: 10px 0 0 10px;
  padding-bottom: 55px;
  box-sizing: border-box;
  .filter {
    width: 100%;
    height: 100%;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    > div {
      width: 100%;
      border-bottom: 1px solid #f6f4f4;
      padding: 0 0px 10px 19px;
      box-sizing: border-box;
    }
    &-title {
      height: 48px;
      display: flex;
      align-items: center;
    }
    &-select-txt {
      width: 240px;
      margin-right: 15px;
      text-align: right;
      color: var(--APP_theme_color);
    }
    &-class {
      font-size: 16px;
      color: #515151;
    }
    .screen-body {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }
    .brand-class {
      width: 86px;
      height: 27px;
      line-height: 27px;
      @include center();
      background: #f1f1f1;
      color: #515151;
      font-size: 12px;
      flex-direction: row;
      margin: 6px 20px 6px 0;
      border-radius: 14px;
      @include ell(1);
      box-sizing: border-box;
      border: 1px solid #f1f1f1;
      padding: 0 5px;
    }
    .brand-class-active {
      border: 1px solid var(--APP_theme_color);
      background: var(--APP_theme_color_colorOpacity1);
      color: var(--APP_theme_color);
    }
  }
  .filter-bottom {
    width: 100%;
    height: 55px;
    position: absolute;
    left: 0;
    bottom: 0;
    border-top: 1px solid #f6f4f4;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 15px;
    background: #fff;
    justify-content: space-around;
    span {
      width: 130px;
      height: 35px;
      @include center();
      border-radius: 18px;
    }
    span:nth-child(1) {
      border: 1px solid #d2d2d2;
      color: #666666;
      box-sizing: border-box;
    }
    span:nth-child(2) {
      background: var(--APP_theme_color);
      color: #fff;
    }
  }
}
// 筛选弹窗end
// 搜索结果为空start
.null_goods {
  text-align: center;
  padding-top: 35px;
  @include center();
  img {
    width: 160px;
    height: 140px;
  }
  p {
    line-height: 30px;
    font-size: 12px;
  }
  a {
    display: block;
    width: 150px;
    height: 35px;
    border-radius: 17.5px;
    font-size: 14px;
    @include center();
    margin-top: 10px;
  }
  .null_see_btn {
    color: #ffffff;
    background: var(--APP_theme_color);
    border: 1px solid var(--APP_theme_color);
  }
  .null_mes_btn {
    color: #666666;
    border: 1px solid #d2d2d2;
  }
}
// 搜索结果为空end
// 优惠券start
.coupon {
  width: 100%;
  background: #feeee1;
  padding: 8px 0;
  &-txt {
    color: #ff6600;
    font-size: 12px;
  }
  &-time {
    display: inline-block;
  }
  .notice {
    margin-left: 8px;
  }
  span {
    color: #e4b18a;
    margin-left: 8px;
  }
  b {
    display: inline-block;
    border: 1px solid #eec19e;
    border-radius: 0.5px;
    width: 15px;
    height: 15px;
    margin-left: 8px;
    color: #f52c40;
    text-align: center;
    line-height: 15px;
  }
}
.pull-refresh{
  min-height: 667px;
}
.change-block{
  /deep/.van-list__loading{
    display:none;
  }
}
// 优惠券end
</style>
